import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  DialogContentText,
  Button,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  List,
  CardContent,
  Typography,
  CardActions,
  Card,
  Chip,
  FormControl,
  InputLabel,
  FilledInput,
  InputAdornment,
  FormHelperText,
  Snackbar,
  OutlinedInput,
  Backdrop,
  CircularProgress,
  Divider,
} from "@mui/material";
import { Form, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import LogoutIcon from "@mui/icons-material/Logout";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import Person3Icon from "@mui/icons-material/Person3";
import StyleIcon from "@mui/icons-material/Style";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { Link as RouterLink } from "react-router-dom";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import PasswordIcon from "@mui/icons-material/Password";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const PaymentDialogContent = (props) => {
  const [user, setUser] = useState(null);
  const [step, setStep] = useState(0);
  const [promoCode, setPromoCode] = useState("");
  const [price, setPrice] = useState("12.99");
  const [planId, setPlanId] = useState(process.env.REACT_APP_PP_PLAN_ID);
  const [promoCodeError, setPromoCodeError] = useState(false);
  const [promoCodeMessage, setPromoCodeMessage] = useState("");

  let rendered = false;
  useEffect(() => {}, []);

  const renderButton = (plan_id) => {
    props.setLoader(true);
    axios
      .get("https://api.fabloq.com/user/profile/details/", {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        setUser(res.data);
        props.setLoader(false);
        if (!rendered) {
          window.paypal
            .Buttons({
              createSubscription: function (data, actions) {
                return actions.subscription.create({
                  plan_id: plan_id, // Creates the subscription
                  subscriber: {
                    email: res.data.email,
                  },
                });
              },
              onApprove: function (data, actions) {
                props.setLoader(true);
                props.setPayDialog(false);
                let post_data = new FormData();
                post_data.append("plan_id", props.selectedPlanId);
                post_data.append("pp_subs_id", data.subscriptionID);
                axios
                  .post(
                    "https://api.fabloq.com/user/profile/plans/checkout/",
                    post_data,
                    {
                      headers: {
                        Authorization: localStorage.getItem("token"),
                      },
                    }
                  )
                  .then((res) => {
                    props.getPlan();
                    props.setLoader(false);
                  });

                console.log(data); // Optional message given to subscriber
              },
              onError(err) {
                // For example, redirect to a specific error page
                props.setSnackbarMessage("Something went wrong");
                props.setSnackbar(true);
              },
            })
            .render("#paypal-button-container");
          rendered = true;
        }
      });
  };

  const verifyPromoCode = () => {
    let data = new FormData();
    data.append("code", promoCode);
    axios
      .post("https://api.fabloq.com/user/profile/plans/promocode/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        if (res.data.status === "error") {
          setPromoCodeError(true);
          setPromoCodeMessage("Invalid Promo Code");
          return;
        }
        setPromoCodeError(false);
        setPromoCodeMessage("");
        setPrice(res.data.price);
        setPlanId(res.data.plan_id);
        setStep(1);
        renderButton(res.data.plan_id);
      });
  };

  if (step === 0) {
    return (
      <div className="payment-confirm-dialog">
        <DialogTitle>Checkout</DialogTitle>
        <DialogContent className="payment-confirm-content">
          <Typography variant="h5" component="div" color="#fff">
            ${price}/month
          </Typography>
          <Divider />
          <TextField
            label="Promo Code"
            value={promoCode}
            onChange={(e) => {
              setPromoCode(e.target.value);
            }}
            error={promoCodeError}
            helperText={promoCodeMessage}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="text">Cancel</Button>
          <Button
            variant="text"
            onClick={() => {
              if (promoCode) {
                verifyPromoCode();
              } else {
                setStep(1);
                renderButton(process.env.REACT_APP_PP_PLAN_ID);
              }
            }}
          >
            Proceed to pay
          </Button>
        </DialogActions>
      </div>
    );
  } else if (step === 1) {
    return (
      <div className="payment-dialog-content">
        <DialogTitle>Checkout</DialogTitle>
        <DialogContent>
          <div id="paypal-button-container"></div>
        </DialogContent>
      </div>
    );
  }
};

const Content = (props) => {
  const [showCurrentPass, setShowCurrentPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [emailMessage, setEmailMessage] = useState("");

  const [currentPass, setCurrentPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  const [currentPassError, setCurrentPassError] = useState(false);
  const [newPassError, setNewPassError] = useState(false);

  const [currentPassMessage, setCurrentPassMessage] = useState("");
  const [newPassMessage, setNewPassMessage] = useState("");

  const [snackbar, setSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [payDialog, setPayDialog] = useState(false);

  const [planId, setPlanId] = useState("");
  const [selectedPlanId, setselectPlanId] = useState("");

  useEffect(() => {
    if (props.step === 2) {
      getPlan();
    }
  }, [props.step]);

  const getPlan = () => {
    props.setLoader(true);
    axios
      .get("https://api.fabloq.com/user/profile/plans/checkout/", {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        setPlanId(res.data.plan);
        props.setLoader(false);
      });
  };

  var emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const handleEmailSubmit = () => {
    if (!emailRegex.test(email)) {
      setEmailError(true);
      setEmailMessage("Please enter a valid email.");
      return;
    }

    let data = new FormData();
    data.append("email", email);
    axios
      .post("https://api.fabloq.com/user/profile/changeemail/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        if (res.data.status === "error") {
          setEmailError(true);
          setEmailMessage(res.data.message);
          return;
        }
        setSnackbar(true);
        setSnackbarMessage("Email changed successfully");
        setEmail("");
        setEmailError(false);
      });
  };

  const handlePasswordSubmit = () => {
    if (!Boolean(currentPass) || !Boolean(newPass) || !Boolean(confirmPass)) {
      if (!Boolean(currentPass)) {
        setCurrentPassError(true);
        setCurrentPassMessage("Please enter current password.");
      }
      if (!Boolean(newPass) && !Boolean(confirmPass)) {
        setNewPassError(true);
        setNewPassMessage("Please enter new password.");
      }
    }
    if (currentPassError || newPassError) {
      return;
    }
    let data = new FormData();
    data.append("new_password", newPass);
    data.append("current_password", currentPass);
    axios
      .post("https://api.fabloq.com/user/profile/changepassword/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        if (res.data.status === "error") {
          setCurrentPassError(true);
          setCurrentPassMessage("Incorrect password");
          return;
        }
        setSnackbar(true);
        setSnackbarMessage("Password changed successfully");
        setNewPassError(false);
        setCurrentPassError(false);
        setNewPass("");
        setCurrentPass("");
        setConfirmPass("");
      });
  };

  const handleCancelSub = (plan_id) => {
    props.setLoader(true);
    let data = new FormData();
    data.append("plan_id", plan_id);
    axios
      .post("https://api.fabloq.com/user/profile/plans/cancel/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        getPlan();
        props.setLoader(false);
      });
  };

  switch (props.step) {
    case 0:
      return (
        <>
          <h2 className="project-page-subtitle">Change Email</h2>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleEmailSubmit();
            }}
          >
            <TextField
              label="Email"
              fullWidth
              className="profile-textfield"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setEmailError(false);
              }}
              error={emailError}
              helperText={emailError ? emailMessage : ""}
            />
            <Button
              variant="contained"
              onClick={(e) => {
                e.preventDefault();
                handleEmailSubmit();
              }}
            >
              Submit
            </Button>
          </form>
          <Snackbar
            open={snackbar}
            autoHideDuration={6000}
            onClose={(e) => {
              setSnackbar(false);
            }}
            message={snackbarMessage}
          />
        </>
      );
    case 1:
      return (
        <>
          <h2 className="project-page-subtitle">Change Password</h2>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handlePasswordSubmit();
            }}
          >
            <FormControl variant="outlined">
              <InputLabel>Current Password</InputLabel>
              <OutlinedInput
                type={showCurrentPass ? "text" : "password"}
                value={currentPass}
                onChange={(e) => {
                  setCurrentPass(e.target.value);
                  setCurrentPassError(false);
                }}
                error={currentPassError}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowCurrentPass(!showCurrentPass)}
                      onMouseDown={(e) => {
                        e.preventDefault();
                      }}
                    >
                      {showCurrentPass ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
              <FormHelperText error={currentPassError}>
                {currentPassError ? currentPassMessage : ""}
              </FormHelperText>
            </FormControl>
            <FormControl variant="outlined">
              <InputLabel>New Password</InputLabel>
              <OutlinedInput
                type={showNewPass ? "text" : "password"}
                value={newPass}
                onChange={(e) => {
                  setNewPass(e.target.value);
                  setNewPassError(false);
                  if (Boolean(confirmPass) && e.target.value !== confirmPass) {
                    setNewPassError(true);
                    setNewPassMessage("Passwords don't match.");
                  }
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowNewPass(!showNewPass)}
                      onMouseDown={(e) => {
                        e.preventDefault();
                      }}
                    >
                      {showNewPass ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <TextField
              label="Confirm Password"
              type="password"
              fullWidth
              className="profile-textfield"
              value={confirmPass}
              onChange={(e) => {
                setConfirmPass(e.target.value);
                setNewPassError(false);
                if (e.target.value !== newPass) {
                  setNewPassError(true);
                  setNewPassMessage("Passwords don't match.");
                }
              }}
              error={newPassError}
              helperText={newPassError ? newPassMessage : ""}
            />

            <Button
              variant="contained"
              onClick={(e) => {
                e.preventDefault();
                handlePasswordSubmit();
              }}
            >
              Submit
            </Button>
          </form>
          <Snackbar
            open={snackbar}
            autoHideDuration={6000}
            onClose={(e) => {
              setSnackbar(false);
            }}
            message={snackbarMessage}
          />
        </>
      );
    case 2:
      return (
        <>
          <Dialog
            open={payDialog}
            onClose={() => {
              setPayDialog(false);
            }}
          >
            <PaymentDialogContent
              setPayDialog={setPayDialog}
              selectedPlanId={selectedPlanId}
              getPlan={getPlan}
              setLoader={props.setLoader}
              snackbar={snackbar}
              setSnackbar={setSnackbar}
              snackbarMessage={snackbarMessage}
              setSnackbarMessage={setSnackbarMessage}
            />
          </Dialog>
          <h2 className="project-page-subtitle">Plans</h2>
          <div className="project-page-plan">
            <Card variant="outlined" className="plan-card">
              <CardContent>
                <div className="plan-card-header">
                  <Typography variant="h5" component="div" color="#fff">
                    Free
                  </Typography>
                  {planId === 1 ? (
                    <Chip
                      label="Current"
                      color="primary"
                      className="plan-card-chip"
                    />
                  ) : (
                    ""
                  )}
                </div>

                <Typography sx={{ mb: 1.5 }} color="#fff">
                  Starter
                </Typography>
                <Typography sx={{ fontSize: 14 }} color="#fff" gutterBottom>
                  What you get
                </Typography>
                <Typography variant="body2" color="#fff">
                  <ul>
                    <li>1 Free project</li>
                  </ul>
                </Typography>
              </CardContent>
              <CardActions>
                <Button size="small" variant="contained" fullWidth disabled>
                  Get This Plan
                </Button>
              </CardActions>
            </Card>
            <Card variant="outlined" className="plan-card">
              <CardContent>
                {/* <Chip
                  label="Current"
                  color="primary"
                  className="plan-card-chip"
                /> */}
                {/* <div className="dummy-chip" /> */}
                <div className="plan-card-header">
                  <Typography variant="h5" component="div" color="#fff">
                    $12.99/month
                  </Typography>
                  {planId === 2 ? (
                    <Chip
                      label="Current"
                      color="primary"
                      className="plan-card-chip"
                    />
                  ) : (
                    ""
                  )}
                </div>
                <Typography sx={{ mb: 1.5 }} color="#fff">
                  Pro
                </Typography>
                <Typography sx={{ fontSize: 14 }} color="#fff" gutterBottom>
                  What you get
                </Typography>
                <Typography variant="body2" color="#fff">
                  <ul>
                    <li>Unlimited Projects</li>
                    <li>Connect Remote Database</li>
                    {/* <li>Get it at $8.99 for one month</li> */}
                  </ul>
                </Typography>
              </CardContent>
              <CardActions>
                {planId === 2 ? (
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() => {
                      handleCancelSub(2);
                    }}
                    fullWidth
                  >
                    Cancel Subscription
                  </Button>
                ) : (
                  <Button
                    size="small"
                    variant="contained"
                    onClick={() => {
                      setselectPlanId(2);
                      setPayDialog(true);
                    }}
                    fullWidth
                  >
                    Get This Plan
                  </Button>
                )}
              </CardActions>
            </Card>
          </div>
          <Snackbar
            open={snackbar}
            autoHideDuration={6000}
            onClose={(e) => {
              setSnackbar(false);
            }}
            message={snackbarMessage}
          />
        </>
      );
  }
};

export const ProfilePage = (props) => {
  const [step, setStep] = useState(0);
  const [loader, setLoader] = useState(false);

  let { tab } = useParams();
  useEffect(() => {
    if (tab === "plans") {
      setStep(2);
    } else if (tab === "settings") {
      setStep(0);
    }
  }, []);

  return (
    <div className="profile-page">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="primary" />
      </Backdrop>
      <div className="project-page-topbar">
        <p className="project-page-title">My Profile</p>
      </div>
      <div className="profile-page-content">
        <div className="sidebar">
          <List
            sx={{
              width: "100%",

              bgcolor: "background.paper",
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            className="sidebar-list"
            // subheader={
            //   <ListSubheader component="div" id="nested-list-subheader">
            //     Nested List Items
            //   </ListSubheader>
            // }
          >
            <ListItemButton
              onClick={() => {
                setStep(0);
              }}
            >
              <ListItemIcon>
                <AlternateEmailIcon color="#ff5757" />
              </ListItemIcon>
              <ListItemText primary="Change Email" />
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setStep(1);
              }}
            >
              <ListItemIcon>
                <PasswordIcon color="#ff5757" />
              </ListItemIcon>
              <ListItemText primary="Change Password" />
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setStep(2);
              }}
            >
              <ListItemIcon>
                <StyleIcon />
              </ListItemIcon>
              <ListItemText primary="My Plan" />
            </ListItemButton>
          </List>
        </div>
        <div className="profile-content">
          <Content step={step} setStep={setStep} setLoader={setLoader} />
        </div>
      </div>
    </div>
  );
};
